// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  CUSTOMER_DATA_OCR_SERVICE_CONFIGURATION,
  SAVE_DECISION_OCR_SERVICE_CONFIGURATION,
} from './constants/upload-id-landing.services.constants';
// Types
import {
  UploadIdDifferentDataCustomerApiParamsType,
  UploadIdDifferentDataCustomerApiResponseType,
} from '../types/upload-id-different-data-customer-api-response.type';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const getOCRCustomerDataService = async (
  ocrValidationId: string
): Promise<[UploadIdDifferentDataCustomerApiResponseType, Response]> =>
  apiUtils.get({
    ...CUSTOMER_DATA_OCR_SERVICE_CONFIGURATION,
    pathParams: {
      orderId: getCheckoutIdFromUrl(),
      ocrValidationId,
    },
  });

const saveDifferentDataDecisionService = async ({
  ocrValidationId,
  status,
}: UploadIdDifferentDataCustomerApiParamsType): Promise<
  [UploadIdDifferentDataCustomerApiResponseType, Response]
> =>
  apiUtils.post({
    ...SAVE_DECISION_OCR_SERVICE_CONFIGURATION,
    params: {
      status,
      validationId: ocrValidationId,
    },
  });

export { getOCRCustomerDataService, saveDifferentDataDecisionService };
